import { Component, EventEmitter, Input, Output, resolveForwardRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { SeasonType } from 'src/app/pages/fleets/interfaces/TyreMaintenanceRecord.interface';
import { FunnelService } from 'src/app/pages/new-service/services/funnel.service';

@Component({
  selector: 'app-wheel-characteristics-input',
  templateUrl: './wheel-characteristics-input.component.html',
  styleUrls: ['./wheel-characteristics-input.component.scss']
})
export class WheelCharacteristicsInputComponent {

  @Input()
  SeasonShow: boolean = true

  @Input()
  Season!: SeasonType;

  @Input()
  Width: string = "";

  @Input()
  Series: string = "";

  @Input()
  Diameter: string = "";

  @Input()
  LoadIndex: string = "";

  @Input()
  SpeedIndex: string = "";

  @Input()
  Brand: string = "";

  @Input()
  Model: string = "";

  @Input()
  IsAntiFlat: boolean = false

  @Input()
  DidWeAlignTyres: boolean = false

  @Input()
  DidWePermuteTyres: boolean = false

  @Input()
  DotCode: string = "";

  @Input()
  wheelMeasureData: any;

  @Input() EditMode: boolean = false;

  @Input() TyreReadingTitle: boolean = false;
  @Input() BrandMdelTitle: boolean = false;
  @Input() DotCodeTitle: boolean = false;

  @Output()
  SeasonEmitter = new EventEmitter();

  @Output()
  WidthEmitter = new EventEmitter();

  @Output()
  SeriesEmitter = new EventEmitter();

  @Output()
  DiameterEmitter = new EventEmitter();

  @Output()
  LoadIndexEmitter = new EventEmitter();

  @Output()
  SpeedIndexEmitter = new EventEmitter();

  @Output()
  BrandEmitter = new EventEmitter();

  @Output()
  ModelEmitter = new EventEmitter();

  @Output()
  IsAntiFlatEmitter = new EventEmitter();

  @Output()
  DidWeAlignTyresEmitter = new EventEmitter();

  @Output()
  DidWePermuteTyresEmitter = new EventEmitter();

  @Output()
  DotCodeEmitter = new EventEmitter();


  SeasonType = SeasonType

  constructor(private funnelService: FunnelService) { }

  ngOnInit() {
    if (this.wheelMeasureData) {
      this.setWidthArray()
    }
  }

  WidthArray: string[] = []
  SeriesArray: string[] = []
  DiameterArray: string[] = []
  LoadIndexArray: string[] = []
  SpeedIndexArray: string[] = []
  BrandArray: string[] = []

  // resetValues() {
  //   this.Series = "";
  //   this.Diameter = "";
  //   this.LoadIndex = "";
  //   this.SpeedIndex = "";
  //   this.Brand = "";
  //   this.Model = "";
  // }

  setSeason(event: SeasonType) {
    this.Season = event;
    this.SeasonEmitter.emit(this.Season);
    if (this.Width) {
      this.loadModels();
    }
  }

  setWidthArray() {
    this.WidthArray = Array.from(Object.keys(this.wheelMeasureData.Width ?? {}))
    if (this.Width) {
      this.setWidth(this.Width);
    }
  }

  setWidth(event: string) {
    this.Width = event;
    this.WidthEmitter.emit(this.Width)
    // this.resetValues();
    this.setSeriesArray();
  }

  setSeriesArray() {
    this.SeriesArray = Array.from(Object.keys(this.wheelMeasureData?.Width?.[this.Width]?.Series ?? {}))

    if (this.SeriesArray && this.SeriesArray.length === 1) {
      this.setSeries(this.SeriesArray[0])
    } else {
      this.setSeries(this.Series && this.SeriesArray.includes(this.Series) ? this.Series : "")
    }
  }

  setSeries(event: string) {
    this.Series = event;
    this.SeriesEmitter.emit(this.Series)
    this.setDiameterArray();

  }

  setDiameterArray() {
    this.DiameterArray = Array.from(Object.keys(this.wheelMeasureData?.Width?.[this.Width]?.Series?.[this.Series]?.Diameter ?? {}))

    if (this.DiameterArray && this.DiameterArray.length === 1) {
      this.setDiameter(this.DiameterArray[0])
    } else {
      this.setDiameter(this.Diameter && this.DiameterArray.includes(this.Diameter) ? this.Diameter : "")
    }
  }

  setDiameter(event: string) {
    this.Diameter = event;
    this.setLoadIndexArray();
    this.DiameterEmitter.emit(this.Diameter)

  }

  setLoadIndexArray() {
    this.LoadIndexArray = Array.from(
      Object.keys(this.wheelMeasureData?.Width?.[this.Width]?.Series?.[this.Series]?.Diameter?.[this.Diameter]?.LoadIndex ?? {})
    );
    if (this.LoadIndexArray && this.LoadIndexArray.length === 1) {
      this.setLoadIndex(this.LoadIndexArray[0])
    } else {
      this.setLoadIndex(this.LoadIndex && this.LoadIndexArray.includes(this.LoadIndex) ? this.LoadIndex : "")
    }
  }

  setLoadIndex(event: string) {
    this.LoadIndex = event;
    this.setSpeedIndexArray();
    this.LoadIndexEmitter.emit(this.LoadIndex)
  }

  setSpeedIndexArray() {
    this.SpeedIndexArray = Array.from(Object.values(this.wheelMeasureData?.Width?.[this.Width]?.Series?.[this.Series]?.Diameter?.[this.Diameter]?.LoadIndex?.[this.LoadIndex]?.SpeedIndex ?? {}));

    if (this.SpeedIndexArray && this.SpeedIndexArray.length === 1) {
      this.setSpeedIndex(this.SpeedIndexArray[0])
    } else {
      this.setSpeedIndex(this.SpeedIndex && this.SpeedIndexArray.includes(this.SpeedIndex) ? this.SpeedIndex : "")
    }
  }

  setSpeedIndex(event: string) {
    this.SpeedIndex = event;
    this.loadModels()
    this.SpeedIndexEmitter.emit(this.SpeedIndex)

  }

  setBrandArray() {
    this.BrandArray = Array.from(this.BrandModelMap.keys());
    if (!this.EditMode) {
      if (this.BrandArray && this.BrandArray.length > 0) {
        this.setBrand(this.BrandArray[0])
      } else {
        this.setBrand(this.Brand && this.BrandArray.includes(this.Brand) ? this.Brand : this.Brand)
      }
    } else {
      this.setBrand(this.Brand)
    }
  }

  setBrand(event: string) {
    this.Brand = event;
    this.BrandEmitter.emit(this.Brand)

    let modelArray = this.BrandModelMap.get(this.Brand);
    if (!this.EditMode) {
      if (modelArray && modelArray.length > 0) {
        this.setModel(modelArray[0])
      } else {
        this.setModel(this.Model && modelArray && modelArray.includes(this.Model) ? this.Model : "")
      }
    } else {
      this.setModel(this.Model)
    }
  }

  setModel(event: string) {
    this.Model = event;
    this.ModelEmitter.emit(this.Model)
  }

  changeIsAntiFlat() {
    this.IsAntiFlat = !this.IsAntiFlat;
    this.loadModels();
    this.IsAntiFlatEmitter.emit(this.IsAntiFlat)

  }

  changeDidWeAlignTyres() {
    this.DidWeAlignTyres = !this.DidWeAlignTyres;
    this.DidWeAlignTyresEmitter.emit(this.DidWeAlignTyres)

  }

  changeDidWePermuteTyres() {
    this.DidWePermuteTyres = !this.DidWePermuteTyres;
    this.DidWePermuteTyresEmitter.emit(this.DidWePermuteTyres)

  }

  setDotCode(event: string) {
    this.DotCode = event;
    this.DotCodeEmitter.emit(this.DotCode)
  }


  BrandModelMap: Map<string, string[]> = new Map();
  loadingModels: boolean = false;

  loadModels() {
    this.loadModelsRequest().then((data: any) => {
      if (data && data['Tyres']) {
        this.BrandModelMap.clear();
        if (!this.EditMode) {
          this.Brand = "";
          this.Model = "";
        }
        data['Tyres'].forEach((tyreInfo: any) => {
          const modelos = this.BrandModelMap.get(tyreInfo.Marca) || [];
          this.BrandModelMap.set(tyreInfo.Marca, [...modelos, tyreInfo.Modelo]);
        });

        this.setBrandArray()
        this.loadingModels = false;

      }
    }).catch(error => {
      console.error("Error loading models:", error);
    });
  }

  private loadModelsSubscription?: Subscription; // Guardamos la suscripción activa

  loadModelsRequest(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.loadingModels = true;
      if (this.loadModelsSubscription) {
        this.loadModelsSubscription.unsubscribe();
      }

      this.loadModelsSubscription = this.funnelService.getTyresModels(
        1,
        this.Width,
        this.Series,
        this.Diameter,
        this.LoadIndex,
        this.SpeedIndex,
        this.IsAntiFlat,
        false, false, false, false, false, false, false, false, false, false, this.Season == SeasonType.ALL_SEASON ? "ALL SEASONS" : this.Season == SeasonType.WINTER ? "WINTER" : this.Season == SeasonType.SUMMER ? "SUMMER" : ""
      ).subscribe({
        next: (data: any) => {
          this.loadModelsSubscription = undefined;
          resolve(data);
        },
        error: (error: any) => {
          this.loadModelsSubscription = undefined;
          reject(error);
        }
      });
    })
  }


}
